import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark' | 'system';

type UIState = {
  sidebarOpen: boolean;
  theme: Theme;
  setSidebarOpen: (open: boolean) => void;
  setTheme: (theme: Theme) => void;
};

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Primeiro acesso em tela estreita (celular): barra recolhida, senão ela ocupa 256 px e
      // empurra o conteúdo para fora da tela. Depois disso vale a escolha persistida da pessoa.
      sidebarOpen: window.matchMedia('(min-width: 768px)').matches,
      theme: 'system',
      setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
      setTheme: (theme) => set({ theme }),
    }),
    { name: 'ui-storage' },
  ),
);

/** Resolve o tema efetivo (`'system'` consulta o SO). Fonte única p/ a classe `.dark` e libs externas que precisem seguir o tema do app. */
export function resolveTheme(theme: Theme): 'light' | 'dark' {
  const isDark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  return isDark ? 'dark' : 'light';
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', resolveTheme(theme) === 'dark');
}
